import { Component, computed, output, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { BaseComponent } from 'src/app/components/_base/base.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './step-3.component.html',
  standalone: true,
  selector: 'app-onboarding-step-3',
  imports: [MatButtonModule, NgClass, TranslatePipe],
  styles: `
    button[mat-button],
    button[mat-flat-button] {
      --mdc-filled-button-container-height: 36px;
      --mdc-text-button-container-height: 36px;
    }
  `,
})
export class Step3Component extends BaseComponent {
  readonly back = output<void>();
  readonly continue = output<number>();

  readonly selectedMethod = signal(-1);

  readonly continueDisabled = computed(() => this.selectedMethod() < 0 || this.selectedMethod() > 1);

  onContinue() {
    if (this.continueDisabled()) return;

    this.continue.emit(this.selectedMethod() === 0 ? 9 : 6);
  }

  onSkip() {
    this.continue.emit(9);
  }
}
